import React, { useState } from "react";
import { MToggle } from "@/components/ui/atoms/MToggle";

const ToggleTest: React.FC = () => {
  const [basic, setBasic] = useState(true);
  const [withLabel, setWithLabel] = useState(false);

  return (
    <div style={{ padding: 32, background: "#f8f8f8", minHeight: "100vh" }}>
      <h1
        style={{
          fontSize: 24,
          fontWeight: 700,
          color: "#473982",
          marginBottom: 24,
        }}
      >
        Toggle Component Demo
      </h1>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#473982",
            marginBottom: 16,
          }}
        >
          Basic Toggle
        </h2>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <MToggle checked={basic} onChange={setBasic} />
          <span style={{ fontSize: 16 }}>{basic ? "On" : "Off"}</span>
        </div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#473982",
            marginBottom: 16,
          }}
        >
          Toggle with Label
        </h2>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <MToggle checked={withLabel} onChange={setWithLabel} />
            <span style={{ fontSize: 16 }}>Enable notifications</span>
          </label>
        </div>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#473982",
            marginBottom: 16,
          }}
        >
          Disabled Toggles
        </h2>
        <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <MToggle checked={false} onChange={() => {}} disabled />
            <span style={{ color: "#bbb", fontSize: 16 }}>Disabled (Off)</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <MToggle checked={true} onChange={() => {}} disabled />
            <span style={{ color: "#bbb", fontSize: 16 }}>Disabled (On)</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ToggleTest;
